import { render } from "./PortfolioView.vue?vue&type=template&id=51138eac"
import script from "./PortfolioView.vue?vue&type=script&lang=js"
export * from "./PortfolioView.vue?vue&type=script&lang=js"

import "./PortfolioView.vue?vue&type=style&index=0&id=51138eac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__